import React from "react"
import ChartContainer from "components/Shared/ChartContainer"
import "./index.scss"
import {
	RadialBar,
	RadialBarChart,
	ResponsiveContainer,
	PolarAngleAxis,
	Legend,
} from "recharts"
import {
	DataTable,
	DataTableBody,
	DataTableHead,
	DataTableHeader,
	DataTableRow,
} from "@walmart-web/livingdesign-components"
import {
	CHART_DATA_KEY,
	CURRENT_REACH_INDEX,
	CURRENT_VENDOR_INDEX,
	CURRENT_WALMART_INDEX,
	PREVIOUS_REACH_INDEX,
	PREVIOUS_VENDOR_INDEX,
	PREVIOUS_WALMART_INDEX,
} from "./SummaryTable.consts"
import SummaryChartContent from "./SummaryChartContent/SummaryChartContent"
import { getAxisDomain, getSummaryTableConfig, getTrendType } from "./utils"
import { useIntl } from "react-intl"
import withVisibility from "components/Shared/Hocs/withVisibility"
import {
	CommercialBenchmarkVsmDetails,
	SummaryPenetration,
} from "./SummaryTable.domain"
import SummaryTableRow from "./SummaryTableRow/SummaryTableRow"

interface SummaryTableProps {
	type: SummaryPenetration
	data: CommercialBenchmarkVsmDetails
	summaryPenetrationType: string
}

const SummaryTable: React.FC<SummaryTableProps> = (props) => {
	const { type, data, summaryPenetrationType } = props
	const intl = useIntl()
	const config = getSummaryTableConfig(type, summaryPenetrationType)
	const trendTypeColors = getTrendType(data.variationDifference)
	let currentRow = -1

	const getSummaryRow = (to: number, from: number, isPoints?: boolean) => {
		currentRow++
		return (
			<SummaryTableRow
				config={config}
				isPoints={isPoints}
				currentRow={currentRow}
				tableData={Object.entries(data).slice(to, from)}
			/>
		)
	}

	return (
		<ChartContainer
			title={{
				id: config.title,
			}}
			className="summary-table"
		>
			<ResponsiveContainer width="100%" height={300}>
				<RadialBarChart
					height={300}
					data={[data]}
					innerRadius="85%"
					outerRadius="110%"
					startAngle={90}
					endAngle={-270}
				>
					<PolarAngleAxis
						type="number"
						domain={getAxisDomain(data.variationDifference)}
						dataKey={CHART_DATA_KEY}
						tick={false}
						fill={trendTypeColors[1]}
					/>
					<RadialBar
						dataKey={CHART_DATA_KEY}
						background={{ fill: trendTypeColors[1] }}
						fill={trendTypeColors[0]}
					/>
					<Legend
						layout="vertical"
						verticalAlign="middle"
						horizOriginX={0}
						key={CHART_DATA_KEY}
						content={
							<SummaryChartContent
								variationDifference={data.variationDifference}
								textColor={trendTypeColors[0]}
							/>
						}
					/>
				</RadialBarChart>
			</ResponsiveContainer>

			<DataTable>
				<DataTableHead>
					<DataTableRow UNSAFE_className="table-header">
						{config.headers.map((headerTitle) => {
							return (
								<DataTableHeader data-testid="table-header" key={headerTitle}>
									{intl.formatMessage({ id: headerTitle })}
								</DataTableHeader>
							)
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{getSummaryRow(CURRENT_VENDOR_INDEX, PREVIOUS_VENDOR_INDEX)}
					{getSummaryRow(CURRENT_WALMART_INDEX, PREVIOUS_WALMART_INDEX)}
					{getSummaryRow(CURRENT_REACH_INDEX, PREVIOUS_REACH_INDEX, true)}
				</DataTableBody>
			</DataTable>
		</ChartContainer>
	)
}

export default withVisibility(SummaryTable)
